'use strict';

angular.module('vendor').directive('catalogViewDetailListing', function($rootScope) {
  return {
    restrict: 'E',
    templateUrl: require('./catalog-view-detail-listing.directive.html')
  }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/views/catalog-view-detail-listing.directive.js
// module id = 928
// module chunks = 0